import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Spinner, Input, Alert, Nav, NavItem, NavLink, TabContent, TabPane,
  FormGroup, Label
} from "reactstrap";
import classnames from "classnames";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  getCarriers,
  createShipment,
  trackShipment,
  getShipmentLabel,
  cancelShipment,
} from "../../../services/shipEntegraService";

const BASE_URL = "https://harmanagelapi.stechomeyazilim.info";

const DURUM_RENKLERI = {
  "Beklemede": "warning",
  "Hazırlanıyor": "info",
  "Kargoya Verildi": "primary",
  "Teslim Edildi": "success",
  "İade": "danger",
};

const BOSTA_DURUM_MAP = {
  "CREATED": "Kargo Oluşturuldu",
  "PICKED_UP": "Teslim Alındı",
  "IN_TRANSIT": "Aktarma Merkezinde",
  "OUT_FOR_DELIVERY": "Dağıtımda",
  "DELIVERED": "Teslim Edildi",
  "FAILED_DELIVERY": "Teslim Edilemedi",
  "RETURNED": "İade",
};

const DEFAULT_SHIPMENT_FORM = {
  carrierId: "",
  receiverName: "",
  receiverPhone: "",
  receiverAddress: "",
  receiverCity: "",
  receiverDistrict: "",
  receiverPostalCode: "",
  weight: "1",
  desi: "1",
  description: "",
  paymentType: "0",
};

const TeslimatYonetimi = () => {
  document.title = "Teslimat Yönetimi | HarmanaGEL";

  const [teslimalar, setTeslimalar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [activeTab, setActiveTab] = useState("tumu");

  // Düzenle modal
  const [editModal, setEditModal] = useState(false);
  const [selectedTeslimat, setSelectedTeslimat] = useState(null);
  const [formData, setFormData] = useState({
    TESLIMAT_DURUMU: "", KARGO_FIRMasi: "", KARGO_TAKIP_NO: "", KARGO_REFERANS_ID: ""
  });

  // ShipEntegra kargo oluştur modal
  const [createModal, setCreateModal] = useState(false);
  const [carriers, setCarriers] = useState([]);
  const [carriersLoading, setCarriersLoading] = useState(false);
  const [shipmentForm, setShipmentForm] = useState(DEFAULT_SHIPMENT_FORM);
  const [shipmentLoading, setShipmentLoading] = useState(false);

  // Takip modal
  const [trackModal, setTrackModal] = useState(false);
  const [trackData, setTrackData] = useState(null);
  const [trackLoading, setTrackLoading] = useState(false);

  const fetchTeslimalar = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/SIPARIS_TESLIMATLARI?$top=500&$orderby=ID desc&$expand=SIPARIS($expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress,CEP_NO);$select=ID,KULLANICI_ID,TOPLAM_TUTAR,SIPARIS_NOTU,KULLANICILAR)`
      );
      const result = await response.json();
      if (result && result.value) setTeslimalar(result.value);
    } catch {
      setError("Teslimalar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  const fetchCarriers = useCallback(async () => {
    setCarriersLoading(true);
    try {
      const list = await getCarriers();
      setCarriers(list);
    } catch (err) {
      setError("Kargo firmaları yüklenemedi: " + err.message);
    } finally {
      setCarriersLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTeslimalar();
  }, [fetchTeslimalar]);

  const showSuccess = (msg) => {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(""), 3500);
  };

  // ---------- Düzenleme ----------
  const handleEdit = (teslimat) => {
    setSelectedTeslimat(teslimat);
    setFormData({
      TESLIMAT_DURUMU: teslimat.TESLIMAT_DURUMU || "Beklemede",
      KARGO_FIRMasi: teslimat.KARGO_FIRMasi || "",
      KARGO_TAKIP_NO: teslimat.KARGO_TAKIP_NO || "",
      KARGO_REFERANS_ID: teslimat.KARGO_REFERANS_ID || "",
    });
    setEditModal(true);
  };

  const handleSave = async () => {
    try {
      await fetch(`${BASE_URL}/SIPARIS_TESLIMATLARI(${selectedTeslimat.ID})`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      showSuccess("Teslimat bilgileri güncellendi.");
      setEditModal(false);
      fetchTeslimalar();
    } catch {
      setError("Güncelleme sırasında hata oluştu.");
    }
  };

  // ---------- ShipEntegra - Kargo Oluştur ----------
  const openCreateModal = (teslimat) => {
    setSelectedTeslimat(teslimat);
    const musteri = teslimat.SIPARIS?.KULLANICILAR;
    setShipmentForm({
      ...DEFAULT_SHIPMENT_FORM,
      receiverName: musteri?.AD_SOYAD || "",
      receiverPhone: musteri?.CEP_NO || "",
      description: `Sipariş #${teslimat.SIPARIS_ID}`,
    });
    setCreateModal(true);
    if (carriers.length === 0) fetchCarriers();
  };

  const handleCreateShipment = async () => {
    if (!shipmentForm.carrierId) {
      setError("Lütfen bir kargo firması seçin.");
      return;
    }
    setShipmentLoading(true);
    try {
      const payload = {
        carrierId: shipmentForm.carrierId,
        receiver: {
          name: shipmentForm.receiverName,
          phone: shipmentForm.receiverPhone,
          address: shipmentForm.receiverAddress,
          city: shipmentForm.receiverCity,
          district: shipmentForm.receiverDistrict,
          postalCode: shipmentForm.receiverPostalCode,
        },
        package: {
          weight: parseFloat(shipmentForm.weight) || 1,
          desi: parseFloat(shipmentForm.desi) || 1,
        },
        description: shipmentForm.description,
        paymentType: parseInt(shipmentForm.paymentType, 10),
        referenceNo: `SIPARIS-${selectedTeslimat.SIPARIS_ID}`,
      };

      const result = await createShipment(payload);

      // Oluşturulan kargo bilgisini veritabanına kaydet
      const kargoFirmaAdi =
        carriers.find(c => String(c.id || c.Id || c.carrierId) === String(shipmentForm.carrierId))?.name ||
        carriers.find(c => String(c.id || c.Id || c.carrierId) === String(shipmentForm.carrierId))?.Name ||
        "ShipEntegra";

      await fetch(`${BASE_URL}/SIPARIS_TESLIMATLARI(${selectedTeslimat.ID})`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          KARGO_FIRMasi: kargoFirmaAdi,
          KARGO_TAKIP_NO: result.barcode || result.trackingNumber || result.tracking_number || "",
          KARGO_REFERANS_ID: result.id || result.shipmentId || result.referenceNo || "",
          TESLIMAT_DURUMU: "Kargoya Verildi",
        }),
      });

      showSuccess(`Kargo başarıyla oluşturuldu! Takip No: ${result.barcode || result.trackingNumber || "-"}`);
      setCreateModal(false);
      fetchTeslimalar();
    } catch (err) {
      setError("Kargo oluşturma hatası: " + err.message);
    } finally {
      setShipmentLoading(false);
    }
  };

  // ---------- ShipEntegra - Takip ----------
  const handleTrack = async (teslimat) => {
    if (!teslimat.KARGO_TAKIP_NO) {
      setError("Bu teslimat için takip numarası yok.");
      return;
    }
    setSelectedTeslimat(teslimat);
    setTrackData(null);
    setTrackModal(true);
    setTrackLoading(true);
    try {
      const data = await trackShipment(teslimat.KARGO_TAKIP_NO);
      setTrackData(data);
    } catch (err) {
      setError("Takip bilgisi alınamadı: " + err.message);
      setTrackModal(false);
    } finally {
      setTrackLoading(false);
    }
  };

  // ---------- ShipEntegra - Etiket ----------
  const handleLabel = async (teslimat) => {
    if (!teslimat.KARGO_REFERANS_ID) {
      setError("Etiket için referans ID bulunamadı.");
      return;
    }
    try {
      const data = await getShipmentLabel(teslimat.KARGO_REFERANS_ID);
      const pdfUrl = data.labelUrl || data.url || data.pdf;
      if (pdfUrl) window.open(pdfUrl, "_blank");
      else setError("Etiket URL'si alınamadı.");
    } catch (err) {
      setError("Etiket alınamadı: " + err.message);
    }
  };

  // ---------- ShipEntegra - İptal ----------
  const handleCancel = async (teslimat) => {
    if (!teslimat.KARGO_REFERANS_ID) {
      setError("İptal için referans ID bulunamadı.");
      return;
    }
    if (!window.confirm("Kargoyu iptal etmek istediğinizden emin misiniz?")) return;
    try {
      await cancelShipment(teslimat.KARGO_REFERANS_ID);
      await fetch(`${BASE_URL}/SIPARIS_TESLIMATLARI(${teslimat.ID})`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ TESLIMAT_DURUMU: "İade" }),
      });
      showSuccess("Kargo iptali başarılı.");
      fetchTeslimalar();
    } catch (err) {
      setError("İptal hatası: " + err.message);
    }
  };

  // ---------- Filtre ----------
  const filteredTeslimalar = useMemo(() => {
    if (activeTab === "tumu") return teslimalar;
    return teslimalar.filter(t => t.TESLIMAT_DURUMU === activeTab);
  }, [teslimalar, activeTab]);

  const durumCounts = useMemo(() => {
    const c = {};
    teslimalar.forEach(t => {
      c[t.TESLIMAT_DURUMU] = (c[t.TESLIMAT_DURUMU] || 0) + 1;
    });
    return c;
  }, [teslimalar]);

  // ---------- Kolonlar ----------
  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Sipariş No",
      accessorKey: "SIPARIS_ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="text-primary fw-medium">#{cell.getValue()}</span>,
    },
    {
      header: "Müşteri",
      accessorKey: "SIPARIS",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => {
        const s = cell.getValue();
        return s?.KULLANICILAR?.AD_SOYAD || "-";
      },
    },
    {
      header: "Kargo Firması",
      accessorKey: "KARGO_FIRMasi",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => cell.getValue() || <span className="text-muted">-</span>,
    },
    {
      header: "Takip No",
      accessorKey: "KARGO_TAKIP_NO",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => cell.getValue()
        ? <span className="fw-medium font-monospace">{cell.getValue()}</span>
        : <span className="text-muted">-</span>,
    },
    {
      header: "Durum",
      accessorKey: "TESLIMAT_DURUMU",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => (
        <Badge color={DURUM_RENKLERI[cell.getValue()] || "secondary"}>
          {cell.getValue() || "Bilinmiyor"}
        </Badge>
      ),
    },
    {
      header: "İşlemler",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cellProps) => {
        const t = cellProps.row.original;
        const hasTracking = !!t.KARGO_TAKIP_NO;
        const hasRef = !!t.KARGO_REFERANS_ID;
        return (
          <div className="d-flex gap-1 flex-wrap">
            <Button color="primary" size="sm" outline onClick={() => handleEdit(t)} title="Düzenle">
              <i className="bx bx-edit" />
            </Button>
            {!hasTracking ? (
              <Button color="success" size="sm" onClick={() => openCreateModal(t)} title="ShipEntegra ile Kargo Oluştur">
                <i className="bx bx-package me-1" />Kargo Oluştur
              </Button>
            ) : (
              <>
                <Button color="info" size="sm" onClick={() => handleTrack(t)} title="Kargo Takip">
                  <i className="bx bx-map-pin me-1" />Takip
                </Button>
                {hasRef && (
                  <>
                    <Button color="secondary" size="sm" outline onClick={() => handleLabel(t)} title="Etiket PDF">
                      <i className="bx bx-printer" />
                    </Button>
                    <Button color="danger" size="sm" outline onClick={() => handleCancel(t)} title="İptal Et">
                      <i className="bx bx-x" />
                    </Button>
                  </>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ], [carriers]);

  const tabItems = [
    { key: "tumu", label: "Tümü", count: teslimalar.length },
    { key: "Beklemede", label: "Beklemede", count: durumCounts["Beklemede"] || 0 },
    { key: "Hazırlanıyor", label: "Hazırlanıyor", count: durumCounts["Hazırlanıyor"] || 0 },
    { key: "Kargoya Verildi", label: "Kargoya Verildi", count: durumCounts["Kargoya Verildi"] || 0 },
    { key: "Teslim Edildi", label: "Teslim Edildi", count: durumCounts["Teslim Edildi"] || 0 },
    { key: "İade", label: "İade", count: durumCounts["İade"] || 0 },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Teslimat Yönetimi" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          {/* Özet Kartlar */}
          <Row className="mb-3">
            {[
              { label: "Toplam Teslimat", count: teslimalar.length, color: "primary", icon: "bx-package" },
              { label: "Beklemede", count: durumCounts["Beklemede"] || 0, color: "warning", icon: "bx-time" },
              { label: "Kargoya Verildi", count: durumCounts["Kargoya Verildi"] || 0, color: "info", icon: "bx-truck" },
              { label: "Teslim Edildi", count: durumCounts["Teslim Edildi"] || 0, color: "success", icon: "bx-check-circle" },
            ].map((item, idx) => (
              <Col md={3} key={idx}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">{item.label}</p>
                        <h4 className="mb-0">{item.count}</h4>
                      </div>
                      <div className={`avatar-sm align-self-center mini-stat-icon rounded-circle bg-${item.color}`}>
                        <span className="avatar-title"><i className={`bx ${item.icon} font-size-24`} /></span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="pt-0 pb-0 border-bottom">
                  <Nav tabs className="nav-tabs-custom">
                    {tabItems.map(tab => (
                      <NavItem key={tab.key}>
                        <NavLink
                          className={classnames({ active: activeTab === tab.key })}
                          onClick={() => setActiveTab(tab.key)}
                          style={{ cursor: "pointer" }}
                        >
                          {tab.label}
                          {tab.count > 0 && (
                            <Badge color="primary" pill className="ms-1">{tab.count}</Badge>
                          )}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                </CardBody>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Sipariş Teslimatları</h4>
                    <div className="d-flex align-items-center gap-2">
                      <Badge color="success" className="px-2 py-1">
                        <i className="bx bxs-package me-1" />
                        ShipEntegra Entegre
                      </Badge>
                      <Button color="primary" size="sm" outline onClick={fetchTeslimalar} disabled={isLoading}>
                        <i className="bx bx-refresh me-1" />Yenile
                      </Button>
                    </div>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={filteredTeslimalar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Teslimat ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Manuel Düzenle Modal */}
      <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
        <ModalHeader toggle={() => setEditModal(false)}>
          Teslimat Güncelle #{selectedTeslimat?.ID}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Teslimat Durumu</Label>
            <Input type="select" value={formData.TESLIMAT_DURUMU}
              onChange={(e) => setFormData({ ...formData, TESLIMAT_DURUMU: e.target.value })}>
              <option value="Beklemede">Beklemede</option>
              <option value="Hazırlanıyor">Hazırlanıyor</option>
              <option value="Kargoya Verildi">Kargoya Verildi</option>
              <option value="Teslim Edildi">Teslim Edildi</option>
              <option value="İade">İade</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Kargo Firması</Label>
            <Input value={formData.KARGO_FIRMasi}
              onChange={(e) => setFormData({ ...formData, KARGO_FIRMasi: e.target.value })}
              placeholder="Yurtiçi, Aras, PTT..." />
          </FormGroup>
          <FormGroup>
            <Label>Kargo Takip No</Label>
            <Input value={formData.KARGO_TAKIP_NO}
              onChange={(e) => setFormData({ ...formData, KARGO_TAKIP_NO: e.target.value })}
              placeholder="Takip numarası" />
          </FormGroup>
          <FormGroup>
            <Label>Referans ID</Label>
            <Input value={formData.KARGO_REFERANS_ID}
              onChange={(e) => setFormData({ ...formData, KARGO_REFERANS_ID: e.target.value })}
              placeholder="ShipEntegra referans ID" />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setEditModal(false)}>İptal</Button>
          <Button color="primary" onClick={handleSave}>Kaydet</Button>
        </ModalFooter>
      </Modal>

      {/* ShipEntegra Kargo Oluştur Modal */}
      <Modal isOpen={createModal} toggle={() => setCreateModal(false)} size="lg" centered>
        <ModalHeader toggle={() => setCreateModal(false)}>
          <i className="bx bxs-package me-2 text-success" />
          ShipEntegra ile Kargo Oluştur — Sipariş #{selectedTeslimat?.SIPARIS_ID}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <h6 className="mb-3 text-muted">Kargo Firması</h6>
              <FormGroup>
                <Label>Taşıyıcı Seç *</Label>
                {carriersLoading ? (
                  <div className="text-center py-2"><Spinner size="sm" /> Yükleniyor...</div>
                ) : (
                  <Input type="select" value={shipmentForm.carrierId}
                    onChange={(e) => setShipmentForm({ ...shipmentForm, carrierId: e.target.value })}>
                    <option value="">-- Kargo Firması Seçin --</option>
                    {carriers.map((c, i) => (
                      <option key={i} value={c.id || c.Id || c.carrierId || c.CarrierId}>
                        {c.name || c.Name || c.carrierName || c.CarrierName || `Firma ${i + 1}`}
                      </option>
                    ))}
                  </Input>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Ödeme Tipi</Label>
                <Input type="select" value={shipmentForm.paymentType}
                  onChange={(e) => setShipmentForm({ ...shipmentForm, paymentType: e.target.value })}>
                  <option value="0">Gönderici Öder</option>
                  <option value="1">Alıcı Öder (Kapıda Ödeme)</option>
                </Input>
              </FormGroup>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Ağırlık (kg)</Label>
                    <Input type="number" min="0.1" step="0.1" value={shipmentForm.weight}
                      onChange={(e) => setShipmentForm({ ...shipmentForm, weight: e.target.value })} />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Desi</Label>
                    <Input type="number" min="1" step="1" value={shipmentForm.desi}
                      onChange={(e) => setShipmentForm({ ...shipmentForm, desi: e.target.value })} />
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup>
                <Label>Açıklama</Label>
                <Input value={shipmentForm.description}
                  onChange={(e) => setShipmentForm({ ...shipmentForm, description: e.target.value })}
                  placeholder="Paket içeriği" />
              </FormGroup>
            </Col>

            <Col md={6}>
              <h6 className="mb-3 text-muted">Alıcı Bilgileri</h6>
              <FormGroup>
                <Label>Ad Soyad *</Label>
                <Input value={shipmentForm.receiverName}
                  onChange={(e) => setShipmentForm({ ...shipmentForm, receiverName: e.target.value })} />
              </FormGroup>
              <FormGroup>
                <Label>Telefon *</Label>
                <Input value={shipmentForm.receiverPhone}
                  onChange={(e) => setShipmentForm({ ...shipmentForm, receiverPhone: e.target.value })} />
              </FormGroup>
              <FormGroup>
                <Label>Şehir *</Label>
                <Input value={shipmentForm.receiverCity}
                  onChange={(e) => setShipmentForm({ ...shipmentForm, receiverCity: e.target.value })}
                  placeholder="İstanbul" />
              </FormGroup>
              <FormGroup>
                <Label>İlçe</Label>
                <Input value={shipmentForm.receiverDistrict}
                  onChange={(e) => setShipmentForm({ ...shipmentForm, receiverDistrict: e.target.value })}
                  placeholder="Kadıköy" />
              </FormGroup>
              <FormGroup>
                <Label>Posta Kodu</Label>
                <Input value={shipmentForm.receiverPostalCode}
                  onChange={(e) => setShipmentForm({ ...shipmentForm, receiverPostalCode: e.target.value })}
                  placeholder="34000" />
              </FormGroup>
              <FormGroup>
                <Label>Adres *</Label>
                <Input type="textarea" rows={2} value={shipmentForm.receiverAddress}
                  onChange={(e) => setShipmentForm({ ...shipmentForm, receiverAddress: e.target.value })}
                  placeholder="Açık adres..." />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setCreateModal(false)} disabled={shipmentLoading}>İptal</Button>
          <Button color="success" onClick={handleCreateShipment} disabled={shipmentLoading}>
            {shipmentLoading ? <><Spinner size="sm" className="me-1" />Oluşturuluyor...</> : <><i className="bx bx-package me-1" />Kargoyu Oluştur</>}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Takip Modal */}
      <Modal isOpen={trackModal} toggle={() => setTrackModal(false)} centered>
        <ModalHeader toggle={() => setTrackModal(false)}>
          <i className="bx bx-map-pin me-2 text-info" />
          Kargo Takip — {selectedTeslimat?.KARGO_TAKIP_NO}
        </ModalHeader>
        <ModalBody>
          {trackLoading ? (
            <div className="text-center py-4"><Spinner color="info" /></div>
          ) : trackData ? (
            <div>
              <div className="mb-3">
                <div className="d-flex justify-content-between mb-1">
                  <span className="text-muted">Durum</span>
                  <Badge color="primary">
                    {BOSTA_DURUM_MAP[trackData.status] || trackData.status || trackData.currentStatus || "-"}
                  </Badge>
                </div>
                {trackData.carrierName && (
                  <div className="d-flex justify-content-between mb-1">
                    <span className="text-muted">Kargo Firması</span>
                    <span>{trackData.carrierName}</span>
                  </div>
                )}
                {trackData.estimatedDelivery && (
                  <div className="d-flex justify-content-between mb-1">
                    <span className="text-muted">Tahmini Teslim</span>
                    <span>{new Date(trackData.estimatedDelivery).toLocaleDateString("tr-TR")}</span>
                  </div>
                )}
              </div>
              {Array.isArray(trackData.events || trackData.history) && (
                <div>
                  <h6 className="mb-2">Kargo Geçmişi</h6>
                  <div className="timeline-list">
                    {(trackData.events || trackData.history).map((ev, i) => (
                      <div key={i} className="d-flex gap-2 mb-2 pb-2 border-bottom">
                        <i className="bx bx-radio-circle-marked text-primary mt-1" />
                        <div>
                          <div className="fw-medium">{ev.description || ev.status || ev.message}</div>
                          <small className="text-muted">
                            {ev.location || ev.city || ""}{" "}
                            {ev.date || ev.timestamp ? new Date(ev.date || ev.timestamp).toLocaleString("tr-TR") : ""}
                          </small>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <p className="text-muted text-center">Takip bilgisi bulunamadı.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setTrackModal(false)}>Kapat</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default TeslimatYonetimi;
